import { STORAGE_KEY } from "@constants";
import { getDevFlags } from "@utils/dev-flags";
import logger from "@utils/logger";
import { AuthToken, Banner, MemberFundingProfileSettings, SelfEntityModel } from "kz-ui-sdk";

/**
 * Persist access token to local storage
 */
export const persistAccessToken = (token: AuthToken | null) => {
  logger._console.log("persist token", token);
  if (token?.access_token) localStorage.setItem(STORAGE_KEY.ACCESS_TOKEN, token.access_token);
  else localStorage.removeItem(STORAGE_KEY.ACCESS_TOKEN);
};

/**
 * Persist post login contact banners to local storage
 */
export const persistMemberContactBanners = (contactBanners: Banner[] | null | undefined) => {
  if (contactBanners) {
    localStorage.setItem(STORAGE_KEY.PRIVATE_CONTACT_BANNERS, JSON.stringify(contactBanners));
  } else if (contactBanners === null) {
    localStorage.removeItem(STORAGE_KEY.PRIVATE_CONTACT_BANNERS);
  }
};

/**
 * Clear onboard storage, used for onboarding process
 */
export const clearOnboardStorage = (phone: string) => {
  localStorage.removeItem(STORAGE_KEY.OTP_TIMEOUT_PREFIX + phone);
  sessionStorage.removeItem(STORAGE_KEY.ONBOARDING_PHONE);
};

/**
 * Refine funding profile settings before storing in redux state
 */
export const refineFundingProfileSettings = (
  settings: MemberFundingProfileSettings | undefined,
): MemberFundingProfileSettings | undefined => {
  if (!settings) return undefined;

  const mergedSettings = JSON.parse(JSON.stringify(settings));
  const devFlags = getDevFlags();
  if (devFlags?.bankConfig) {
    mergedSettings.supportedTypes.bank = {
      ...mergedSettings.supportedTypes.bank,
      ...devFlags.bankConfig,
    };
  }
  if (devFlags?.ewalletConfig) {
    mergedSettings.supportedTypes["e-wallet"] = {
      ...mergedSettings.supportedTypes["e-wallet"],
      ...devFlags.ewalletConfig,
    };
  }
  return mergedSettings;
};

/**
 * Refine self data before storing in redux state
 */
export const refineSelf = (data: SelfEntityModel | undefined): SelfEntityModel | null => {
  let self = data ? { ...data } : null;
  if (self?.member?.phone) {
    // Clear onboard storage
    clearOnboardStorage(self?.member?.phone);
  }
  // trim fullname
  if (self?.member?.fullname) {
    self = {
      ...self,
      member: {
        ...self.member,
        fullname: self.member.fullname.trim(),
      },
    };
  }
  return self;
};
